// extracted by mini-css-extract-plugin
module.exports = {"Requestwidthdraw":"main_Requestwidthdraw__3LCPe"};